import React from 'react';
import Input from 'components/forms/Input';
import Tooltip from 'components/Tooltip';
import { DeleteOutlined } from '@ant-design/icons';
import InputLabel from '../common/InputLabel';
import OutputLabel from '../common/OutputLabel';
import FormRow from './FormRow';
import PricePerSelect from './PricePerSelect';

const InputWithSelectRow = ({
    id,
    editableTitle = false,
    pricePerSelected,
    onInputChange,
    currency,
    onSelectChange,
    onChangeTitle = null,
    removeItem = null,
    title,
    value, // input
    amount, // calculated depending on pricePerSelected
    selectStyles,
}) => (
    <FormRow
        style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: '10px',
        }}
    >
        {editableTitle ? (
            <Input
                placeholder="Other"
                style={{
                    width: '40%',
                    marginRight: '0px',
                }}
                onChange={(event) => onChangeTitle(id, event.target.value)}
                value={title}
                className="pkgCalc-form-number"
            />
        ) : (
            <InputLabel className="pkgCalc-form-label" text={title} />
        )}
        <Input
            type="number"
            placeholder="0"
            onChange={(event) => onInputChange(id, event.target.value)}
            className="pkgCalc-form-number"
            value={value}
            addonBefore={currency}
        />
        <PricePerSelect
            selectedOption={pricePerSelected}
            handleChange={(event) => onSelectChange(id, event.value)}
            selectStyles={selectStyles}
        />
        <OutputLabel text={`${currency}${amount !== 'NaN' ? amount : 0}`} />
        <Tooltip title="Warning - this will remove this item" placement="right">
            <DeleteOutlined onClick={() => removeItem(id)} />
        </Tooltip>
    </FormRow>
);

export default InputWithSelectRow;
